<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="物品详情"
        v-loading="loading"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12">
                        <div class="label">物品名称：</div>
                        <div class="content">{{ msg.name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">购买数量：</div>
                        <div class="content">{{ msg.qty }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">购买金额：</div>
                        <div class="content">{{ msg.price }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">购买时间：</div>
                        <div class="content">{{ msg.purchase_time }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">单位：</div>
                        <div class="content">{{ msg.unit }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">使用部门：</div>
                        <div class="content">{{ msg.full_depart_name }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">状态：</div>
                        <div class="content">
                            <el-tag
                                size="mini"
                                :type="
                                    msg.status == 1
                                        ? 'warning'
                                        : msg.status == 2 ||
                                        msg.status == 4
                                        ? 'info'
                                        : msg.status == 3
                                        ? 'danger'
                                        : ''
                                "
                            >
                                {{ msg.status_cn }}
                            </el-tag>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">使用员工：</div>
                        <div class="content">{{ msg.user_name }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">物品详情：</div>
                        <div class="content">{{ msg.desc }}</div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    name: "thingsAdminDetail",
    data() {
        return {
            loading: false,
            msg: {},
        };
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                    this.commodity();
                }
            },
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
    },
    methods: {
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        commodity() {
            oaApi.commodity({}, "get", this.tableItem.id).then((res) => {
                //console.log(res);
                if (res.code == 200) {
                    this.msg = res.data;
                }
            });
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>

</style>